import React from "react";
// import NavBar from "../sections/NavBar";
// import Footer from "../sections/Footer";
import { useNavigate } from "react-router-dom";
import sideArrow from "../../images/icons/sideArrow.png";

export default function TermsConditions() {
  const navigate = useNavigate();
  const terms = [
    {
      title: " General",
      content: `These Terms govern all bookings and rides provided by Carzen logistics. 
      By confirming a booking, you accept that you understand and agree to these Terms.`,
    },
    {
      title: " Service Availability",
      content: `We aim to provide reliable and timely transportation services. However, 
      availability depends on factors including driver availability, traffic, weather, and operational conditions.`,
    },
    {
      title: " Booking & Ride Confirmation",
      list: [
        "Bookings may be made through our website, mobile app, phone, or authorized partners.",
        "A booking is confirmed only once you receive a confirmation message or email.",
        "We reserve the right to decline, cancel, or modify bookings if required for operational reasons.",
      ],
    },
    {
      title: " User Responsibilities",
      list: [
        "Provide accurate pickup and drop-off information.",
        "Be ready at the pickup location on time.",
        "Maintain respectful behavior toward drivers.",
        "Avoid illegal activities in the vehicle.",
        "Use seatbelts for your safety.",
      ],
      afterNote:
        "We may refuse service if a passenger is intoxicated, threatening, or violates safety rules.",
    },
    {
      title: " Driver Responsibilities",
      list: [
        "Arrive at the pickup location on time.",
        "Drive safely and follow traffic regulations.",
        "Keep the vehicle clean and well-maintained.",
        "Treat passengers with professionalism and respect.",
      ],
    },
    {
      title: " Fares & Payment",
      list: [
        "Fares include base fare, distance/time charges, taxes, tolls, and any applicable surcharges.",
        "Surge pricing may apply during peak hours or high-demand situations.",
        "Payment methods include cash, card, digital wallets, UPI, and any methods specified on our website/app.",
        "Electronic receipts will be provided upon completion of the ride.",
      ],
    },
    {
      title: " Waiting & Delay Charges",
      list: [
        "A free waiting period of [X minutes] applies.",
        "After the free waiting period, waiting charges will be added to the fare.",
        "If a delay is caused by the customer, additional charges may apply.",
      ],
    },
    {
      title: " Cancellation Policy",
      list: [
        "Customer cancellations may incur a cancellation fee depending on the timing relative to the driver’s arrival.",
        "If the driver cancels without valid reason, no fee will be charged to the customer.",
        "Specific cancellation fees will be displayed during booking.",
      ],
    },
    {
      title: " No-Show Policy",
      content: `A no-show fee applies if the driver arrives at the pickup location but you are not present or reachable within [X minutes] of arrival.`,
    },
    {
      title: " Luggage & Personal Belongings",
      list: [
        "Passengers are responsible for their belongings.",
        "Carzen Logistics is not liable for items left behind in the vehicle.",
        "Hazardous, illegal, or oversized items are not permitted.",
      ],
    },
    {
      title: " Safety & Conduct",
      list: [
        "Smoking, alcohol consumption, and drug use inside the cab are strictly prohibited.",
        "Passengers must follow driver safety instructions.",
        "Drivers may refuse service in unsafe or inappropriate situations.",
      ],
    },
    {
      title: " Limitation of Liability",
      list: [
        "Delays due to traffic, weather, or unforeseen events.",
        "Loss or damage to personal belongings.",
        "Indirect or consequential damages arising from the use of our Service.",
      ],
      afterNote:
        "Our liability is limited to proven cases of direct negligence by our employees or representatives.",
    },
    {
      title: " Shared/Pool Rides (If Applicable)",
      list: [
        "Routes may be adjusted to accommodate multiple passengers.",
        "Passengers must respect one another and follow shared-ride guidelines.",
      ],
    },

    {
      title: " Modification of Terms",
      content:
        "We may update these Terms periodically. Continued use of our Service constitutes acceptance of updated Terms.",
    },
  ];

  return (
    <>
      {/* <div className="max-w-6xl md:mx-auto mx-4">
        <NavBar />
      </div> */}

      <div className="max-w-9xl mx-auto  md:pb-10">
        {/* Back Button */}
        {/* <button
          onClick={() => navigate("/")}
          className="mb-6 inline-flex items-center gap-2 text-sm sm:text-base 
        text-gray-700 px-4 py-2 rounded-lg transition"
        >
          Back to Home
        </button> */}
        <div className="bg-[#CCA065] md:mb-10  mb-9  text-white content-center">
          <button
            onClick={() => navigate("/")}
            className="mb-6 lg:ml-9 lg:mt-4 inline-flex items-center content-start gap-2 text-sm sm:text-base 
        text-white px-4 py-2 rounded-lg transition"
          >
            {" "}
            <span className=" lg:px-2 w-7 h-7 md:w-[30px] md:h-[30px] flex items-center justify-center bg-white rounded-full">
              <img
                src={sideArrow}
                className="w-3 h-3 object-contain"
                alt="arrow"
              />
            </span>
            {/* Back to Home */}
          </button>
          <h1 className="mx-2 text-2xl  md:text-5xl font-bold text-gray-100 ml-4  lg:ml-40">
            Terms & Conditions
          </h1>
          <p className="mx-2 mt-4 mb-10 lg:mb-16 text-sm md:text-[18px] ml-4  lg:ml-40">
            Please read these terms and conditions carefully before using our
            services.
          </p>
        </div>
        <div className="max-w-5xl md:mx-auto mx-4">
          {terms.map((item, index) => (
            <div key={index} className="mb-10">
              <h2 className="text-xl sm:text-2xl font-semibold text-[#CCA065] mb-3">
                {item.title}
              </h2>

              {item.content && (
                <p className="text-gray-600 text-[14px] md:text-[18px] leading-relaxed">
                  {item.content}
                </p>
              )}

              {item.list && (
                <ul className="text-[14px] md:text-[18px] list-disc pl-6 text-gray-600 space-y-2">
                  {item.list.map((point, i) => (
                    <li key={i}>{point}</li>
                  ))}
                </ul>
              )}

              {item.afterNote && (
                <p className="mt-3 text-[14px] md:text-[18px] text-gray-600 italic">
                  {item.afterNote}
                </p>
              )}

              <div className="border-b border-gray-300 mt-6"></div>
            </div>
          ))}
        </div>
      </div>
      {/* <Footer /> */}
    </>
  );
}
